var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7794 1.84865L5.88478 10.7431L5.01685 14.2781C4.96817 14.476 5.02666 14.685 5.17067 14.8292C5.31523 14.9737 5.52439 15.0317 5.72171 14.9832L9.25692 14.1152L18.1513 5.22062L14.7794 1.84865ZM19.7419 2.3834L17.6164 0.258076C17.2723 -0.0860255 16.7142 -0.0860255 16.3701 0.258076L15.5238 1.10436L18.8956 4.47615L19.7419 3.62987C20.086 3.28558 20.086 2.7275 19.7419 2.3834ZM6.32235 13.063L6.9367 13.6775L8.57816 13.2743L8.33333 11.6667L6.72532 11.4217L6.32235 13.063Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.3335,
    width: 1.66666,
    height: 16.6667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.6665,
    width: 1.66666,
    height: 8.33333,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18.3335,
    width: 16.6666,
    height: 1.66667,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 3.3335,
    width: 8.33331,
    height: 1.66667,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5b17d4b4216064966c98f54334cca087.svg";
export { ForwardRef as ReactComponent };